import axios from 'axios'
import { getAccessToken, getUserToken } from '@/auth/auth.utils'

const rawClientesUrl = import.meta.env.VITE_API_CLIENTES_URL || ''
const clientesBaseUrl = rawClientesUrl.replace(/\/v[12]\/?$/, '').replace(/\/$/, '')
const CONSUMIDOR_CLIENTES = 'CLIENTES'

const SERVICE_URLS = {
  clientes: clientesBaseUrl,
  company: import.meta.env.VITE_API_COMPANY_URL,
  checkMail: `${import.meta.env.VITE_API_CHECK_MAIL_URL}/v1`,
  organization: `${import.meta.env.VITE_API_ORGANIZATION_URL}/v1`,
  adminUsuario: `${import.meta.env.VITE_API_ADMIN_USUARIO_URL}/v2`,
  registroUsuario: `${import.meta.env.VITE_API_REGISTRO_USUARIO_URL}/v1`,
}

export function createGateway(serviceKey = 'clientes') {
  const instance = axios.create({
    baseURL: SERVICE_URLS[serviceKey],
    timeout: 300_000,
    withCredentials: true,
  })

  instance.interceptors.request.use((config) => {
    const token = getAccessToken() || getUserToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    config.headers.consumidor = CONSUMIDOR_CLIENTES
    return config
  })

  return instance
}
